<template lang="pug">
  .font-size-xxs.policies(
    v-if="action === 'signup'"
    v-html=`__("By signing up, you agree to Rogue's <a aria-label='Link to: Privacy Policy (opens in a new tab)' href='{privacy}' target='_blank'>Privacy Policy</a>, <a aria-label='Link to: Terms of Use (opens in a new tab)' href='{terms}' target='_blank'>Terms of Use</a>, and <a aria-label='Link to: Return Policy (opens in a new tab)' href='{returns}' target='_blank'>Return Policy</a>", {privacy, terms, returns})`
  )
  .font-size-xxs.policies(
    v-else
    v-html=`__("By clicking Place Order, you agree to Rogue's <a aria-label='Link to: Privacy Policy (opens in a new tab)' href='{privacy}' target='_blank'>Privacy Policy</a>, <a aria-label='Link to: Terms of Use (opens in a new tab)' href='{terms}' target='_blank'>Terms of Use</a>, and <a aria-label='Link to: Return Policy (opens in a new tab)' href='{returns}' target='_blank'>Return Policy</a>", {privacy, terms, returns})`
  )
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()

defineProps({
  action: {
    type      : String,
    default   : 'signup',
    validator : (value: string) => ['signup', 'placeOrder'].includes(value),
  },
})

const privacy = computed(() => `${rogue.l10n.path}/privacy-policy`)
const terms = computed(() => `${rogue.l10n.path}/terms-of-use`)
const returns = computed(() => `${rogue.l10n.path}/return-policies`)
</script>

<style lang="scss" scoped>
.policies {
  line-height: 1.5;
}
</style>

<style lang="scss">
.newsletter-signup .policies a {
  color: $color-gray-light;

  &:hover {
    color: $color-gray-dark;
  }
}
</style>
